import { z } from "zod";

export const posterGenerationSchema = z.object({
  eventId: z.string(),
  styleId: z.string().min(1, "Style is required"),
  addText: z.boolean(),
  creationGuidance: z.string().max(200).optional(),
});

export type PosterGenerationForm = z.infer<typeof posterGenerationSchema>;

export const defaultPosterGenerationSchemaValues = {
  eventId: "",
  styleId: "",
  addText: false,
  creationGuidance: "",
};
